import React from 'react';

export const PlantByTheWindow = props => (
  <svg width="204px" height="162px" viewBox="0 0 204 162" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-240.000000, -283.000000)">
        <g transform="translate(240.000000, 283.000000)">
          <path
            d="M151.569827,153.828286 L55.4303682,153.828286 L3.50857005,101.847549 C2.83047665,101.168692 2.83047665,100.057914 3.50857005,99.3790569 L102.267034,0.508488428 C102.945999,-0.169496143 104.054655,-0.169496143 104.732749,0.508488428 L203.492084,99.3790569 C204.169305,100.057914 204.169305,101.168692 203.492084,101.847549 L151.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <g>
            <polyline
              fill="#FFFFFF"
              points="0.7998 34.6771 0.7998 0.7191 14.3978 0.7191"
            />
            <polyline
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.7998 34.6771 0.7998 0.7191 14.3978 0.7191"
            />
          </g>
          <g transform="translate(5.000000, 15.710000)">
            <polyline
              fill="#FFFFFF"
              points="33.3487 0.7191 77.1537 0.7191 77.1537 99.4061 0.7997 99.4061 0.7997 64.8761"
            />
            <polyline
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="33.3487 0.7191 77.1537 0.7191 77.1537 99.4061 0.7997 99.4061 0.7997 64.8761"
            />
          </g>
          <polygon
            fill="#F3F4F6"
            points="13.843 68.083 74.506 68.083 74.506 24.728 13.843 24.728"
          />
          <polygon
            fill="#F3F4F6"
            points="13.843 102.313 74.506 102.313 74.506 76.995 13.843 76.995"
          />
          <polygon
            fill="#FFFFFF"
            points="0.841 118.91 86.324 118.91 86.324 110.68 0.841 110.68"
          />
          <polygon
            stroke="#DCE4E7"
            points="0.841 118.91 86.324 118.91 86.324 110.68 0.841 110.68"
          />
          <polygon
            fill="#FFFFFF"
            points="0.841 16.429 86.324 16.429 86.324 8.198 0.841 8.198"
          />
          <polygon
            stroke="#DCE4E7"
            points="0.841 16.429 86.324 16.429 86.324 8.198 0.841 8.198"
          />
          <g transform="translate(17.000000, 37.710000)">
            <path
              d="M21.8223,5.5131 C20.7933,4.4951 19.4483,4.7231 19.4483,4.7231 C19.4483,4.7231 20.0023,2.2041 16.3613,1.0591 C12.7203,-0.0869 11.1373,2.3311 11.1373,2.3311 C9.1593,0.8051 7.6553,2.5861 6.9433,3.7321 C6.2313,4.8771 5.6763,6.0231 3.3823,6.2771 C1.0863,6.5321 0.8493,8.6951 0.8493,8.6951 L24.7513,8.6951"
              fill="#FFFFFF"
            />
            <path
              d="M21.8223,5.5131 C20.7933,4.4951 19.4483,4.7231 19.4483,4.7231 C19.4483,4.7231 20.0023,2.2041 16.3613,1.0591 C12.7203,-0.0869 11.1373,2.3311 11.1373,2.3311 C9.1593,0.8051 7.6553,2.5861 6.9433,3.7321 C6.2313,4.8771 5.6763,6.0231 3.3823,6.2771 C1.0863,6.5321 0.8493,8.6951 0.8493,8.6951 L24.7513,8.6951"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M43.6504,46.4047 L45.8584,46.4047"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(56.000000, 49.710000)">
            <path
              d="M18.3853,2.0883 C17.9193,1.6253 17.2193,1.1833 16.1753,0.8543 C12.5333,-0.2917 10.9513,2.1263 10.9513,2.1263 C8.9723,0.6003 7.4683,2.3813 6.7563,3.5263 C6.0443,4.6723 5.4893,5.8173 3.1953,6.0713 C0.8993,6.3263 0.6623,8.4893 0.6623,8.4893 L18.5643,8.4893"
              fill="#FFFFFF"
            />
            <path
              d="M18.3853,2.0883 C17.9193,1.6253 17.2193,1.1833 16.1753,0.8543 C12.5333,-0.2917 10.9513,2.1263 10.9513,2.1263 C8.9723,0.6003 7.4683,2.3813 6.7563,3.5263 C6.0443,4.6723 5.4893,5.8173 3.1953,6.0713 C0.8993,6.3263 0.6623,8.4893 0.6623,8.4893 L18.5643,8.4893"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M39.3492,39.4174 C40.5022,37.6334 42.5082,36.4524 44.7902,36.4524 C48.3652,36.4524 51.2642,39.3514 51.2642,42.9264 C51.2642,46.5014 48.3652,49.3994 44.7902,49.3994 C43.2882,49.3994 41.9072,48.8884 40.8082,48.0304"
            stroke="#F2C217"
            strokeWidth="0.5"
          />
          <path
            d="M41.5049,41.891 C41.9459,40.46 43.2799,39.42 44.8559,39.42 C46.7919,39.42 48.3619,40.99 48.3619,42.926 C48.3619,43.411 48.2639,43.871 48.0869,44.29"
            stroke="#F2C217"
            strokeWidth="0.5"
          />
          <path
            d="M139.2627,157.7319 C139.2627,160.0419 129.9557,161.9139 118.4757,161.9139 C106.9957,161.9139 97.6897,160.0419 97.6897,157.7319 C97.6897,155.4219 106.9957,153.5499 118.4757,153.5499 C129.9557,153.5499 139.2627,155.4219 139.2627,157.7319"
            fill="#D0D7DA"
          />
          <g transform="translate(116.000000, 99.710000)">
            <path
              d="M11.3618,1.1361 C10.0828,0.2461 4.6668,1.7841 2.3418,5.1231 C0.0168,8.4611 -0.1332,12.6921 2.1898,14.3091 C4.5118,15.9261 8.4268,14.3181 10.7518,10.9791 C13.0758,7.6411 12.6408,2.0271 11.3618,1.1361"
              fill="#CBD62A"
            />
            <path
              d="M11.3618,1.1361 C10.0828,0.2461 4.6668,1.7841 2.3418,5.1231 C0.0168,8.4611 -0.1332,12.6921 2.1898,14.3091 C4.5118,15.9261 8.4268,14.3181 10.7518,10.9791 C13.0758,7.6411 12.6408,2.0271 11.3618,1.1361"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g>
            <path
              d="M1.2134,1.2308 C0.4814,2.0818 1.1864,6.0748 3.4064,7.9848 C5.6284,9.8948 8.6474,10.3128 9.9764,8.7678 C11.3044,7.2228 10.4404,4.2998 8.2194,2.3898 C5.9984,0.4798 1.9444,0.3798 1.2134,1.2308"
              fill="#A3C23A"
            />
            <path
              d="M1.2134,1.2308 C0.4814,2.0818 1.1864,6.0748 3.4064,7.9848 C5.6284,9.8948 8.6474,10.3128 9.9764,8.7678 C11.3044,7.2228 10.4404,4.2998 8.2194,2.3898 C5.9984,0.4798 1.9444,0.3798 1.2134,1.2308"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(94.000000, 113.710000)">
            <path
              d="M0.69,16.9281 L0.69,34.1221 C0.69,38.7041 4.404,42.4171 8.985,42.4171 L40.091,42.4171 C44.672,42.4171 48.386,38.7041 48.386,34.1221 L48.386,0.9431 L0.69,0.9431 L0.69,9.9771"
              fill="#FFFFFF"
            />
            <path
              d="M0.69,16.9281 L0.69,34.1221 C0.69,38.7041 4.404,42.4171 8.985,42.4171 L40.091,42.4171 C44.672,42.4171 48.386,38.7041 48.386,34.1221 L48.386,0.9431 L0.69,0.9431 L0.69,9.9771"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M127.2051,144.4145 L95.6901,144.4145"
            stroke="#F2C217"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M140.6236,147.4018 C140.6236,151.5928 133.8416,153.9768 133.8416,153.9768 L133.8416,116.2708 L140.6236,116.2708 L140.6236,147.4018 Z"
            fill="#F2F3F3"
          />
          <path
            d="M141.3863,144.4145 L130.8533,144.4145"
            stroke="#F2C217"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M178.9571,153.5502 L147.2121,153.5502"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.126,153.5502 L37.37,153.5502"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.3697,153.5502 L19.3337,153.5502"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M120.1636,75.9945 L120.1636,77.9945"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M120.1636,81.9945 L120.1636,83.9945"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M124.1636,79.9945 L122.1636,79.9945"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M118.1636,79.9945 L116.1636,79.9945"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M161.1299,116.2709 C161.1299,117.1099 160.4509,117.7899 159.6119,117.7899 C158.7739,117.7899 158.0939,117.1099 158.0939,116.2709 C158.0939,115.4329 158.7739,114.7529 159.6119,114.7529 C160.4509,114.7529 161.1299,115.4329 161.1299,116.2709"
            fill="#F05F4C"
          />
          <path
            d="M99.208,89.6537 C99.208,90.4927 98.528,91.1727 97.69,91.1727 C96.852,91.1727 96.172,90.4927 96.172,89.6537 C96.172,88.8157 96.852,88.1357 97.69,88.1357 C98.528,88.1357 99.208,88.8157 99.208,89.6537"
            fill="#CBD62A"
          />
          <polygon
            fill="#FFFFFF"
            points="132.533 143.894 141.273 143.894 141.273 141.95 132.533 141.95"
          />
          <g>
            <path d="M0.1895,5.309 L4.1375,0.19" />
            <path
              d="M0.1895,5.309 L4.1375,0.19"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M74.564,130.3324 L74.564,132.3324"
            stroke="#7350A0"
            strokeLinecap="round"
          />
          <path
            d="M74.564,136.3324 L74.564,138.3324"
            stroke="#7350A0"
            strokeLinecap="round"
          />
          <path
            d="M78.564,134.3324 L76.564,134.3324"
            stroke="#7350A0"
            strokeLinecap="round"
          />
          <path
            d="M72.564,134.3324 L70.564,134.3324"
            stroke="#7350A0"
            strokeLinecap="round"
          />
          <g>
            <path d="M0.4961,0.9818 L3.9761,3.7678" fill="#CBD62A" />
            <path
              d="M0.4961,0.9818 L3.9761,3.7678"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polyline
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="73.0044 77.9945 14.1384 77.9945 14.1384 102.3125"
          />
          <polyline
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="74.1299 24.7279 14.5879 24.7279 14.5879 60.8499"
          />
          <polygon
            fill="#F3F4F6"
            points="86.8174 110.2065 86.8174 119.1215 3.8404 119.1215 8.8404 124.0945 89.3244 124.0945 89.3244 121.0155 89.3244 119.1215 89.3244 112.7125"
          />
          <path
            d="M86.7896,71.4652 C86.7896,72.3032 86.1106,72.9832 85.2716,72.9832 C84.4336,72.9832 83.7536,72.3032 83.7536,71.4652 C83.7536,70.6262 84.4336,69.9472 85.2716,69.9472 C86.1106,69.9472 86.7896,70.6262 86.7896,71.4652"
            fill="#DCE4E7"
          />
          <g>
            <path d="M0.272,0.7191 L0.272,54.2381" fill="#FFFFFF" />
            <path d="M0.272,0.7191 L0.272,54.2381" stroke="#DCE4E7" />
          </g>
          <g>
            <path d="M0.8413,0.3334 L19.1303,0.3334" fill="#FFFFFF" />
            <path
              d="M0.8413,0.3334 L19.1303,0.3334"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g>
            <path d="M0.8413,0.2113 L28.9123,0.2113" fill="#FFFFFF" />
            <path
              d="M0.8413,0.2113 L28.9123,0.2113"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g>
            <path d="M0.4097,0.4242 L25.4807,0.4242" fill="#FFFFFF" />
            <path
              d="M0.4097,0.4242 L25.4807,0.4242"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M139.1206,45.0434 L139.1206,53.9214"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.9038,53.9213 L153.9038,64.1343"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g>
            <path d="M0.6568,0.6224 L14.3618,0.6224" fill="#FFFFFF" />
            <path
              d="M0.6568,0.6224 L14.3618,0.6224"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g>
            <path d="M0.2857,0.6224 L0.2857,4.6224" fill="#FFFFFF" />
            <path
              d="M0.2857,0.6224 L0.2857,4.6224"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
